import { useCallback, useEffect, useState } from "react";
import { checkWhitelistRestrictionAction } from "../Actions/whiteListpsAction";

const useIpRestrictionCheck = () => {
  const [isCheckingIp, setIsCheckingIp] = useState(() => {
    const token = localStorage.getItem("token");
    return !token;
  });

  const [ipRestrictionData, setIpRestrictionData] = useState(null);
  // console.log("ipRestrictionData", ipRestrictionData);
  const [isIpBlocked, setIsIpBlocked] = useState(false);
  // console.log("isIpBlocked", isIpBlocked);
  const [blockMessage, setBlockMessage] = useState("");

  const checkUsersIpRestriction = useCallback(async () => {
    setIsCheckingIp(true);
    setIsIpBlocked(false);
    setBlockMessage("");

    try {
      let ip = null;
      const response = await checkWhitelistRestrictionAction(ip);
      const {
        status = false,
        message = "",
        ipBlocked = false,
        accessGranted = true
      } = response;

      if (!status) {
        console.error(message || "Something went wrong while checking the ip");
        return;
      }

      // Check if IP is blocked
      const blocked = ipBlocked || !accessGranted;
      setIsIpBlocked(blocked);

      if (blocked) {
        setBlockMessage(message || "Your IP address has been blocked.");
      }

      setIpRestrictionData(response);
    } catch (err) {
      console.error("Error while checking IP restriction:", err);
      const statusCode = err?.status;

      if ([403].includes(statusCode)) {
        // IP is blocked - 403 Forbidden
        setIsIpBlocked(true);
        setBlockMessage(err?.message || "Your IP has been blocked due to security restrictions.");
        setIpRestrictionData({
          ...err,
          ipBlocked: true,
          accessGranted: false
        });
      } else {
        setIsIpBlocked(false);
        setIpRestrictionData({ hasError: true });
        console.error(err?.message || "Something went wrong while checking the ip");
      }
    } finally {
      setIsCheckingIp(false);
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) checkUsersIpRestriction();
  }, [checkUsersIpRestriction]);

  return {
    isCheckingIp,
    ipRestrictionData,
    isIpBlocked,
    blockMessage,
    recheckIpRestriction: checkUsersIpRestriction
  };
};

export default useIpRestrictionCheck;